import { API } from '@/api/API'
import { apiEntities } from '@/api/Helpers'
import { indexItemsById } from '@/helpers/IndexHelpers'
import type { QueryParams } from '@/helpers/QueryStringParameters'

export interface MembershipRules {
  rules: MembershipRuleEntity[]
  ticketTypes: TicketType[]
  indexedTypes: Dict<TicketType>
}

export function getMembershipRules(query?: QueryParams): Promise<MembershipRules> {
  return API.getCached<'membership_rules' | 'ticket_type'>('membership_rules', {
    embed: 'ticket_type',
    limit: 1000,
    query,
  }).then((response) => {
    const entities = apiEntities(response)
    return {
      rules: entities.membership_rules,
      ticketTypes: entities.ticket_type,
      indexedTypes: indexItemsById(entities.ticket_type),
    }
  })
}
